// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vant from 'vant'
import 'vant/lib/index.css'
import VueResource from 'vue-resource'
import axios from '../node_modules/axios'
// 引入全局样式
import './assets/css/global.css';

Vue.prototype.$axios = axios
Vue.config.productionTip = false

Vue.use(Vant)
Vue.use(VueResource)

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

new Vue({
  el: '#app',
  router,
  axios,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js